import React from 'react'
import Icon from './Icon'
import PrimaryButton from './PrimaryButton'
import { Link } from 'gatsby'

const CategoryEnquiries = ({ href, title }) => {
  const data = {
    contacts: [
      {
        icon: 'mail',
        title: 'By Email',
        gtmTag: 'email us',
        contact: '',
        text: '',
        href: href,
        button: 'Email Us',
      },
    ],
  }

  return (
    <>
      <div className="flex mb-8">
        {data.contacts.map((item, index) => (
          <Link
            to={item.href}
            tabIndex="0"
            className={`flex w-full`}
            key={index}
          >
            <div className="relative flex items-stretch w-full flip-card__container">
              <div className="flex flex-col items-start justify-between w-full p-6 rounded-lg flip-card__side flip-card__side--front bg-secondary bg-gradient-br-primary">
                <div className="flex-auto w-full mb-8 text-white">
                  <div className="flex items-start">
                    <div className="flex items-center justify-center">
                      <div className="z-10 flex items-center justify-center w-10 h-10 mr-4 rounded-full bg-secondary">
                        <Icon
                          icon={item.icon}
                          className="w-2/3 text-white fill-current"
                        />
                      </div>
                      <h4 className="m-0 text-2xl font-semibold">{title}</h4>
                    </div>
                    <div className="ml-auto">
                      <PrimaryButton light>
                        <span className="text-secondary">{item.button}</span>
                      </PrimaryButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </>
  )
}

export default CategoryEnquiries
